import { Box, BoxProps, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Scroll from "react-scroll";
import { Magnolia } from "domain/Magnolia";

interface Props extends BoxProps {
  backgroundColor?: string;
  fullWidth?: boolean;
  gradient?: { top: string; bottom: string };
  noMargin?: boolean;
  spacingFactor?: number;
  spacingFactorBottom?: number;
  multisite?: Magnolia.MultisiteId;
  id?: string;
  isJobpageComponent?: boolean;
}

interface StyleProps {
  backgroundColor?: string;
  gradient?: { top: string; bottom: string };
  multisite?: Magnolia.MultisiteId;
  fullWidth?: boolean;
}
const useStyles = makeStyles((theme: Theme) => ({
  container: (props: StyleProps) => ({
    backgroundColor: props.backgroundColor || "inherit",
    backgroundImage: props.gradient
      ? `linear-gradient(0deg, ${props.gradient.bottom} 50%, ${props.gradient.top} 50%)`
      : "none",
    ...(props.multisite === "krahnCeramics" && {
      maxWidth: props.fullWidth ? "100% !important" : 1390,
      margin: "0 auto",
    }),
  }),
}));

const Section: React.FC<Props> = ({
  children,
  fullWidth = false,
  noMargin = false,
  spacingFactor = 10,
  spacingFactorBottom = 10,
  multisite,
  id,
  isJobpageComponent,
  ...props
}) => {
  const displayFullWidth =
    fullWidth || (multisite === "krahnCeramics" && isJobpageComponent);

  // extract backgroundColor to prevent box attribute error
  const { backgroundColor, ...boxProps } = props;
  const classes = useStyles({
    backgroundColor,
    multisite,
    gradient: props.gradient,
    fullWidth: displayFullWidth,
  });
  const width =
    multisite === "krahnCeramics" ? (isJobpageComponent ? 1390 : 1140) : 1390;
  const spacing =
    multisite === "krahnCeramics"
      ? {
          xs: 2,
          sm: 3,
          md: 3,
          lg: 0,
          xl: 0,
        }
      : {
          xs: displayFullWidth ? 0 : 2,
          sm: displayFullWidth ? 0 : 3,
          md: displayFullWidth ? 0 : 4,
          lg: displayFullWidth ? 0 : 7,
          xl: 0,
        };

  return (
    <Scroll.Element name={id ?? ""} id={id ?? ""}>
      <Box
        pt={
          noMargin
            ? undefined
            : { xs: 2, sm: spacingFactor / 2, md: spacingFactor }
        }
        pb={
          noMargin
            ? undefined
            : { xs: 2, sm: spacingFactorBottom / 2, md: spacingFactorBottom }
        }
        px={fullWidth ? 0 : "inherit"}
        className={classes.container}
        component={multisite === "krahnCeramics" ? "div" : "section"}
        {...boxProps}
      >
        <Box maxWidth={fullWidth ? "auto" : width} margin="0 auto" px={spacing}>
          {children}
        </Box>
      </Box>
    </Scroll.Element>
  );
};

export default Section;
